<template>
  <div class="serviceList">
    <div class="serviceMain">
      <div class="infosearch">        
        <span class="labelTit">日期</span>
        <el-date-picker
          v-model="orderTime"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions2"
          style="width: 260px;margin-right: 10px"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
        <el-button
          class="searchBtn"
          @click="search(1)"
          v-loading.fullscreen.lock="fullscreenLoading"
        ></el-button>
        <el-button class="darkBtn" @click="outportExcel">导出</el-button>
      </div>
      <el-table
        v-if="tableData.length > 0"
        :data="tableData"
        :summary-method="getSummaries"
        show-summary
        height="532"
        ref="multipleTable"
        :cell-class-name="tableRowClassName"
        class="myMemTable"
        style="width: 100%"
        :header-cell-style="{background:'#EFF1F5'}"
      >
        <el-table-column align="center" prop="createTime" label="日期" show-overflow-tooltip width="150"></el-table-column>
        <el-table-column align="center" prop="cashierName" label="现金" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="cashierName" label="微信" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="cashierName" label="支付宝" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="cashierName" label="银行卡" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column align="center" prop="name" label="充值账号" show-overflow-tooltip></el-table-column> -->
        <el-table-column align="center" prop="cashierName" label="赠送账号" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="cashierName" label="返现账号" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="cashierName" label="优惠" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="cashierName" label="打折" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="cashierName" label="抹零" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="cashierName" label="应收" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="cashierName" label="实收" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="cashierName" label="找零" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="cashierName" label="充值金额" show-overflow-tooltip></el-table-column>
      </el-table>
      <template v-else>
        <div class="emptys">查不到对账总计信息！再核对一下试试</div>
      </template>

      <el-pagination
        v-if="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 20px;text-align:right"
      ></el-pagination>
    </div>
  </div>
</template>
<script type="text/javascript">
import { formatDate} from '@/components/common/js/date.js';
import { queryRechargePage, exportChargeList } from "@/api";
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  data() {
    return {
      pickerOptions2: {
        onPick: ({ maxDate, minDate }) => {
          this.pickerMinDate = minDate.getTime()
          if (maxDate) {
            this.pickerMinDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate != '') {
              const one = 90 * 24 * 3600 * 1000
              const minTime = this.pickerMinDate - one
              const maxTime = this.pickerMinDate + one
              return time.getTime() < minTime || time.getTime() > maxTime
            }
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      pickerMinDate:'',
      memName: "",
      orderTime: [formatDate(new Date(new Date().getTime() - 3600 * 1000 * 24 * 30),'yyyy-MM-dd 00:00:00'),formatDate(new Date(),'yyyy-MM-dd 23:59:59')],
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
      mySearchflag: false,
      fullscreenLoading: false,
    };
  },
  created() {
    this.currentPage =  this.$store.state.alivePage;
    this.search();
    this.$store.commit("setAlivePage", 1);//取消页码状态
  },
  methods: {
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      //把每一行的索引放进row
      if (rowIndex % 2 == 1) {
        return "highLight";
      }
      return "";
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    async search(val) {
      this.fullscreenLoading = true;
      if (val == 1) {
        this.currentPage = 1;
      }
      let res = await queryRechargePage({
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        rechargeType:'1',
        startDate:this.orderTime?this.orderTime[0]:'',
        endDate:this.orderTime?this.orderTime[1]:'',
        name:this.memName
      });
      this.fullscreenLoading = false;
      if(res.code == 0){
        this.$message({
          message: res.msg,
          type: 'error'
        });
        return;
      }
      if (res.data.rows.length == 0) {
        this.mySearchflag = true;
      }
      this.total = res.data.total;
      this.tableData = res.data.rows;
    },
    getSummaries(param){
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = '￥'+sums[index].toFixed(2)
          } else {
            sums[index] = 'N/A';
          }
        });

        return sums;
    },
    outportExcel(){
      if(!this.orderTime || this.orderTime.length == 0){
        this.$message({
          message: '请选择日期！',
          type: 'error'
        });
        return
      }
      let postData = {
        rechargeType:'1',
        name:this.memName,
        startDate:this.orderTime?this.orderTime[0]:'',
        endDate:this.orderTime?this.orderTime[1]:''
      }
      this.$http.post(exportChargeList, postData, {
        headers:{
          userId:this.$store.state.userInfo.redisKey
        },
        responseType: "blob"
      })
      .then(res => {      
        if(res.data.type == "application/json"){
          this.$message({
            message: '无对账总计信息！',
            type: 'error'
          });
          return
        }  
        const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
        const fileName = '对账总计.xls';
        if('msSaveOrOpenBlob' in navigator){
            navigator.msSaveOrOpenBlob(blob, '对账总计.xls');
            return;
        }
        if ('download' in document.createElement('a')) {
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        }else{
          navigator.msSaveBlob(blob, fileName);
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
.serviceMain {
  padding: 25px 0;
  .labelTit {
    color: #666;
    margin-right: 5px;
  }
  .infosearch {
    .el-input__inner {
      border-radius: 20px;
    }
    .searchBtn {
      width: 47px;
      height: 38px;
      background: #f83b56 url(../../assets/images/store/btn_datalist_search.png)
        no-repeat center;
    }
  }
  .myMemTable {
    margin-top: 25px;
    border: 1px solid #d5d9e3;
    .redFont{
      color: #F83B56;
      span{
        color: #666
      }
    }
    .greenFont{
      color: #2ECFA7
    }
    .blueFont{
      color: #21A3F5;
      span{
        color: #666
      }
    }
    .el-button--mini {
      padding: 8px;
      font-weight: bold;
    }
    .el-button + .el-button {
      margin-left: 0;
    }
    .tableGoods {
      .myTitle {
        width: 100%;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .defaults,
  .emptys {
    height: 600px;
    background: url(../../assets/images/store/img_vip_inquire.png) no-repeat
      center;
    text-align: center;
    font-size: 15px;
    color: #666;
    padding-top: 450px;
  }
  .emptys {
    background: url(../../assets/images/store/img_vip_none.png) no-repeat center;
  }
}
</style>
<style lang="less">
.serviceList {
  .el-dialog__title {
    font-weight: bold;
  }
}
.serviceMain {
  .el-date-editor .el-range-separator {
    width: 26px;
  }
}
.myMemTable {
  .operation {
    .cell {
      padding: 0;
    }
  }
  .el-table__header {
    background: rgb(239, 241, 245);
  }
  .highLight {
    background: #eff1f5;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/businessManagementCenter/cashFlow.vue